<template>
  <div>
    <v-container>
      Photos
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Photos'
};
</script>
